import React from 'react';
import * as PhosphorIcons from '@phosphor-icons/react';

const TransactionAnalyzerViewResult = ({ result }) => {
  const getRiskLevelColor = (severity) => {
    switch(severity?.toLowerCase()) {
      case 'high':
        return 'bg-error/20 text-error';
      case 'medium':
        return 'bg-warning/20 text-warning';
      case 'low':
        return 'bg-success/20 text-success';
      default:
        return 'bg-base-200 text-base-content';
    }
  };

  return (
    <div>
      <h1>Transaction Analyzer</h1>

      {/* Fraud Indicators Card */}
      {result?.transaction_analysis?.fraud_indicators && (
        <div className="card bg-base-100 shadow-sm">
          <div className="card-body p-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="p-2 rounded-lg bg-warning/10">
                <PhosphorIcons.Shield size={20} weight="bold" className="text-warning"/>
              </div>
              <h3 className="card-title text-lg">Fraud Analysis</h3>
            </div>

            <div className="space-y-3">
              <div className="p-3 bg-base-200 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-medium">Recommendation</span>
                  <span className={`px-2 py-0.5 rounded-full text-xs ${
                    result.transaction_analysis.fraud_indicators.recommendation === 'no_action'
                      ? 'bg-success/20 text-success'
                      : 'bg-warning/20 text-warning'
                  }`}>
                    {result.transaction_analysis.fraud_indicators.recommendation.replace(/_/g, ' ')}
                  </span>
                </div>

                {Array.isArray(result.transaction_analysis.fraud_indicators.suspicious_factors) && 
                 result.transaction_analysis.fraud_indicators.suspicious_factors.length > 0 && (
                  <div className="mt-2">
                    <span className="text-sm text-base-content/70">Suspicious Factors:</span>
                    <div className="mt-1 space-y-2">
                      {result.transaction_analysis.fraud_indicators.suspicious_factors.map((factor, idx) => (
                        <div key={idx} className="p-2 bg-base-300 rounded-lg">
                          <div className="flex items-center justify-between">
                            <span className="font-medium capitalize">{factor.type?.replace(/_/g, ' ')}</span>
                            <span className={`px-2 py-0.5 rounded-full text-xs ${getRiskLevelColor(factor.severity)}`}>
                              {factor.severity}
                            </span>
                          </div>
                          {factor.details && (
                            <div className="mt-1 text-sm">{factor.details}</div>
                          )}
                          {factor.risk_score != null && (
                            <div className="mt-1 text-sm">
                              <span className="text-base-content/70">Risk Score: </span>
                              <span>{Math.round(factor.risk_score * 100)}%</span>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionAnalyzerViewResult;